<template>
  <div class="custom-classes-chooser-check">
    <div class="header">
      <div class="title">已选择班级</div>
      <div v-if="classesChecked"
           class="extra">
        <el-button type="text"
                   @click="clearSelection">
          <span>清除全部</span>
          <i class="el-icon-delete"></i>
        </el-button>
      </div>
    </div>
    <AppScrollbar v-if="classesChecked"
                  class="main">
      <div class="select-list">
        <el-tree :data="selectTree"
                 :default-expanded-keys="expandNodes"
                 :props="defaultProps"
                 node-key="label"
                 @node-expand="handleTreeExpand"
                 @node-collapse="handleTreeCollapse">
          <template #default="{node, data}">
            <span class="select-tree-node"
                  :class="{'is-leaf': node.isLeaf}">
              <span v-if="node.isLeaf"
                    class="head"
                    :title="node.label">
                <i class="iconfont icon-banji"></i>
                {{node.label}}
              </span>
              <span v-else
                    class="head">
                <i class="iconfont icon-nianjizu"></i>
                {{node.label}}（{{data.count}}）
              </span>
              <span class="tail">
                <el-button v-if="node.isLeaf"
                           type="text"
                           icon="iconfont icon-shanchu"
                           @click="removeClasses(data.gradeName, data.classesName)"></el-button>
                <el-button v-else
                           type="text"
                           icon="iconfont icon-shanchu"
                           @click="removeGrade(data.gradeName)"></el-button>
              </span>
            </span>
          </template>
        </el-tree>
      </div>
    </AppScrollbar>
    <Hint v-else
          type="empty"
          class="main">
      <span>未勾选班级</span>
    </Hint>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'CustomClassesChooserCheck',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    select: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      expandNodes: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      }
    }
  },
  computed: {
    classesChecked () {
      return Object.keys(this.select).some(key => this.select[key].length)
    },
    selectTree () {
      let treeData = []
      let gradeNames = Object.keys(this.select)
      gradeNames.sort((o1, o2) => o1 > o2 ? -1 : 1)
      gradeNames.forEach(key => {
        let classesNameList = this.select[key]
        if (classesNameList && classesNameList.length) {
          treeData.push({
            label: `${key}级`,
            gradeName: key,
            count: classesNameList.length,
            children: classesNameList.map(classesName => {
              return {
                label: classesName,
                leaf: true,
                gradeName: key,
                classesName: classesName
              }
            })
          })
        }
      })
      return treeData
    }
  },
  methods: {
    handleTreeExpand (data) {
      this.expandNodes.push(data.label)
    },
    handleTreeCollapse (data) {
      let index = this.expandNodes.indexOf(data.label)
      if (index >= 0) {
        this.expandNodes.splice(index, 1)
      }
    },
    clearSelection () {
      Object.keys(this.select).forEach(key => {
        this.select[key] = []
      })
    },
    removeGrade (gradeName) {
      this.select[gradeName] = []
    },
    removeClasses (gradeName, classesName) {
      let classesNames = this.select[gradeName]
      if (classesNames) {
        let index = classesNames.indexOf(classesName)
        if (index >= 0) {
          classesNames.splice(index, 1)
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .custom-classes-chooser-check {
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      position: relative;
      padding: 10px 15px;
      & > .title {
        color: #909399;
        font-size: 12px;
      }
      & > .extra {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        .el-button {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
    & > .main {
      flex: auto;
      .select-list {
        .el-tree {
          background-color: transparent;
          .select-tree-node {
            flex: auto;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 13px;
            &.is-leaf {
              & > .head {
                color: #909399;
              }
            }
            i {
              font-size: 13px;
            }
            & > .head {
              overflow: hidden;
              text-overflow: ellipsis;
            }
            & > .tail {
              padding-right: 5px;
              .el-button {
                &:hover {
                  i {
                    color: #606266;
                  }
                }
                i {
                  color: #909399;
                }
              }
            }
          }
        }
      }
    }
    .layout-hint {
      width: 100%;
    }
  }
</style>
